module.exports = __webpack_public_path__ + "static/media/train_55.56b30304.jpg";